
import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import { InView } from 'react-intersection-observer';

import {SearchResult} from "features/search/types";
import {ResidenceType, StageStatus} from 'features/search/filters/enums';

import {Map} from 'components/organisms/Map';
import {ThirdPartyMapBlock} from 'components/organisms/Map/ThirdPartyMapBlock';

interface Props {
    thirdPartyCookie: boolean;
    residences?: SearchResult[];
    marker?: { lat: number, lng: number, stageStatus?: StageStatus, residenceType?: ResidenceType }
}

export const MapWrapper: React.FunctionComponent<Props> = ({thirdPartyCookie, residences, marker}) => {
    return (
        <InView triggerOnce>
            {({inView, ref}) => (
                <div ref={ref} className="map google-maps__container">
                    {!inView ? (
                        <div><FormattedMessage id='jm.components.StagePage.loading'/></div>
                    ) : (
                        <>
                            {thirdPartyCookie
                                ? <Map residences={residences} customOffsetMobile={110} customOffsetDesktop={55} marker={marker}  />
                                : <ThirdPartyMapBlock
                                    renderOnAccept={<div/>}
                                    narrow
                                />
                            }
                        </>
                    )}
                </div>
            )}
        </InView>
    )
};

/*
<Map
                                googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${GOOGLE_MAPS_API_KEY}&v=3.exp&libraries=geometry,drawing,places`}
                                loadingElement={<TemplateLoader/>}
                                containerElement={<div className="map__container"/>}
                                mapElement={<div className="map__element"/>}
                                // @ts-expect-error
                                showCards
                                residences={residences}
                                marker={marker}
                                isMobile={false}
                            />
 */
